"use strict";
// Copyright © Veeam Software Group GmbH
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthToken = void 0;
class AuthToken {
    constructor(accessTokenStorage, refreshTokenStorage, tokenRefresher) {
        this.accessTokenStorage = accessTokenStorage;
        this.refreshTokenStorage = refreshTokenStorage;
        this.tokenRefresher = tokenRefresher;
    }
    getValue() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.accessTokenStorage.getToken();
        });
    }
    setValue(accessToken, refreshToken) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.accessTokenStorage.setToken(accessToken);
            if (refreshToken) {
                yield this.refreshTokenStorage.setToken(refreshToken);
            }
        });
    }
    hasToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const token = yield this.getValue();
            return !!token;
        });
    }
    refresh() {
        return __awaiter(this, void 0, void 0, function* () {
            const [accessTokenOld, refreshTokenOld] = yield Promise.all([
                this.accessTokenStorage.getToken(),
                this.refreshTokenStorage.getToken()
            ]);
            const { accessToken, refreshToken } = yield this.tokenRefresher({
                accessToken: accessTokenOld,
                refreshToken: refreshTokenOld
            });
            yield Promise.all([
                accessToken ? this.accessTokenStorage.setToken(accessToken) : Promise.resolve(null),
                refreshToken ? this.refreshTokenStorage.setToken(refreshToken) : Promise.resolve(null)
            ]);
        });
    }
    clear() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all([
                this.accessTokenStorage.setToken(''),
                this.refreshTokenStorage.setToken('')
            ]);
        });
    }
}
exports.AuthToken = AuthToken;
//# sourceMappingURL=AuthToken.js.map